import React from 'react'

const SocialMediaIcons = () => {
  return (
    <div className='flex justify-center md:justify-start my-10 gap-7'>
        <a 
            className='hover:opacity-50 transition duration-500'
            href="https://www.linkedin.com/in/connectskw/"
            target='_blank'
            rel='noreferrer'
        >
            <img src="../assets/linkedin.png" alt="linkedin-link" width={24} height={24}/>
        </a>
        <a 
            className='hover:opacity-50 transition duration-500'
            href="https://github.com/KanchanaSW"
            target='_blank'
            rel='noreferrer'
        >
            <img src="../assets/github.png" alt="github-link" width={24} height={24}/>
        </a>
        {/* <a 
            className='hover:opacity-50 transition duration-500'
            href=""
            target='_blank'
            rel='noreferrer'
        >
            <img src="../assets/facebook.png" alt="facebook-link" />
        </a>
        <a 
            className='hover:opacity-50 transition duration-500'
            href=""
            target='_blank'
            rel='noreferrer'
        >
            <img src="../assets/instagram.png" alt="instagram-link" />
        </a> */}
    </div>
  )
}

export default SocialMediaIcons